import React from "react";
import { Platform, StyleSheet, TextInput, TextInputProps } from "react-native";
import { Button as _Button } from "src/common/assets/mixins";

const CustomTextInput = ({ style, ...props }: TextInputProps) => {
  return <TextInput {...props} style={[styles.text, style]} />;
};

const styles = StyleSheet.create({
  text: {
    fontFamily: "Montserrat",
    color: "white",
    fontWeight: "400",
    lineHeight: 20,
    fontSize: 16,
    ...(Platform.OS === 'web' && { outlineStyle: "none" }),
  } as any,
});

export default CustomTextInput;
